module.exports = ":host{width:100%;font-size:14px;display:block}:host span.required{color:red}"